<template>
  <div class="container-fluid footer-container">
    <div class="col-lg-6 m-auto">
      <div class="row">
        <div class="col-12 col-sm-6 sponsor-section pt-5 pb-0 pb-sm-5">
        <template v-if="loaded && workshop">
          <template v-if="workshop.sponsors && workshop.sponsors.data && Object.keys(workshop.sponsors.data).length">
            <div class="title">{{ $t('medtastic.sponsor_text') }}</div>
            <template v-for="sponsor in workshop.sponsors.data">
              <a v-if="sponsor.sponsor && sponsor.sponsor.data && sponsor.sponsor.data.picture"
                 :href="sponsor.sponsor.data.link" target="_blank">
                <img :src="'/storage/' + sponsor.sponsor.data.picture.path">
              </a>
            </template>
          </template>
        </template>
        </div>
        <event-footer-text></event-footer-text>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EventFooterText from './EventFooterText'

export default {
  components: {
    EventFooterText
  },
  layout: 'user',
  data () {
    return {
      loaded: false,
      workshop: null
    }
  },
  mounted () {
    this.workshopDetail()
  },
  methods: {
    workshopDetail: function () {
      axios.get('/api/medtastic/workshops/public?include=sponsor_checkboxes,sponsors.sponsor.sponsor_checkboxes&filter%5Bid%5D=' + this.$route.params.id)
          .then((response) => {
            this.workshop = response.data.data[0]
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
    }
  }
}
</script>
